module.exports = __webpack_public_path__ + "img/dashboard.1a241ad8.svg";